import WhatsAppSipIvrsAPI from 'dashboard/api/whatsappSip/ivrs';

// LEITURA das URAs publicadas (ex.: seletor de destino de time condition).
// Escrita acontece exclusivamente pelo publish do fluxo no builder
// (ivrFlows/publish) — o CRUD granular de IVR foi removido do backend.
export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipIvrsAPI.get();
      const ivrs = data.ivrs || data || [];
      commit('SET_RECORDS', ivrs);
      return ivrs;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipIvrsAPI.show(id);
    return data.ivr || data;
  },
};

export const mutations = {
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  SET_RECORDS($state, records) {
    $state.records = records;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
